<template funtional>
  <div class="items-center">
    <p class="text-xl text-dark font-bold items-center">
      <feather-icon v-if="icon" :icon="icon" svgClasses="h-3 w-3" class=""/>
    {{title}}</p>
  </div>

</template>

<script>
export default {
  props: ['title', 'icon'],
}
</script>
